import { useEffect } from 'react';
import { useShopPayContext } from '../../contexts/ShopPayContext';

const ShopPayEmailField = ({
  containerId = '',
  textFieldId = '',
}: {
  containerId?: string;
  textFieldId?: string;
}) => {
  const { isShopPaySessionCreated } = useShopPayContext();

  useEffect(() => {
    if (
      isShopPaySessionCreated &&
      window.ShopPay &&
      textFieldId !== '' &&
      containerId !== ''
    ) {
      window.ShopPay.PaymentRequest.createLogin({
        emailInputId: textFieldId,
      }).render(`#${containerId}`);
    }
  }, [isShopPaySessionCreated, containerId, textFieldId]);

  return null;
};

export default ShopPayEmailField;
